import type { AxiosResponse } from 'axios';
import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V2 } from '@studio/constants/env-variables';
import type { EncoderOnboarding } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/onboarding`,
    method: HTTP_METHODS.GET,
    response: [] as EncoderOnboarding.Get.Encoder[],
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V2}/onboarding`,
    query: {} as {
      replace?: boolean;
    },
    method: HTTP_METHODS.POST,
    request: {} as EncoderOnboarding.Post.Encoder,
    response: {} as AxiosResponse,
  },
};

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/onboarding/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.GET,
    response: {} as EncoderOnboarding.Get.Encoder,
  },
};
